export default __webpack_public_path__ + "1.19.2/static/media/back-arrow.9e35e3eb.svg";